import dayjs from '@/lib/dayjs';

export const getPanelType = (bookingItinerary, bookingInformation) => {
  // return 2
  let showVal = 2;
  let date1 = new Date().getTime();
  let firstliveitinfound = false;
  let depDateTime;
  bookingItinerary.itinerary.forEach(function (itineraryBlock) {
    itineraryBlock.data.forEach(function (itineraryitem) {
      if (itineraryitem.statusonrecord !== "CANCELLED" && !firstliveitinfound) {
        depDateTime = dayjs(
          `${itineraryitem.depdate} ${itineraryitem.deptime}`,
          "ddd DD MMM YYYY HH:mm"
        );
        date1 = new Date(itineraryitem.depdate).getTime();
        firstliveitinfound = true;
      }
    });
  });
  const timeStamp = new Date().getTime();
  const timeStampYesterday = timeStamp - 24 * 3600000;
  const isbeforeyesterday = date1 >= timeStampYesterday;
  if (bookingInformation.fil.toUpperCase() === "P") {
    showVal = 1;
  } else if (
    dayjs().isBetween(depDateTime.format(), dayjs().subtract(1, "day"))
  ) {
    showVal = 3;
  } else if (
    dayjs(depDateTime.format()).isBetween(
      dayjs().format(),
      dayjs().add(1, "day")
    )
  ) {
    showVal = 3;
  } else if (bookingInformation.departed === "false" && date1 >= timeStamp) {
    showVal = 2;
  } else if (bookingInformation.departed === "true") {
    showVal = 3;
  } else if (bookingItinerary.itinerary[0]) {
    if (date1 >= isbeforeyesterday && bookingInformation.departed === "false") {
      showVal = 3;
    }
  }
  return showVal;
};

export const checkIfFlightAfterNow = (item) => {
  const now = new Date().getTime();
  let flightTime;
  // if (item.deptime !== "TBC") {
  //   flightTime = new Date(item.depdate + " " + item.deptime).getTime();
  // } else {
  flightTime = new Date(item.depdate).getTime();
  // }

  return now < flightTime;
};

const isDST = (date) => {
  const january = new Date(date.getFullYear(), 0, 1);
  const july = new Date(date.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
  return date.getTimezoneOffset() < stdTimezoneOffset;
}
const adjustForDST = (date, isDST) => {
  const offset = date.getTimezoneOffset() * 60000; // Convert offset to milliseconds

  if (isDST) {
    date.setTime(date.getTime() + 3600000); // Add one hour (in milliseconds) for DST
}
  // Adjust the date based on the offset
  date.setTime(date.getTime() + offset);
  return date;
}

export const generateCountDownTimerString = (_depDate) => {
  const depDate = new Date(_depDate)
  if (depDate) {
    const isCurrentlyDST = isDST(depDate); // Determine if DST is active
    const adjustedDate = adjustForDST(depDate, isCurrentlyDST);
    const today = new Date()
    // const offset = new Date(depDate).getTimezoneOffset();
    const flightDate = adjustedDate
    // flightDate.setTime(flightDate.getTime() + offset)
    const countDownDate = flightDate.getTime();
    // Get today's date and time
    const now = today.getTime();
    // Find the distance between now and the count down date
    const distance = countDownDate - now;
    // If the count down is finished, write some text
    if (distance < 0) {
      return null;
    } else {
      // Time calculations for days, hours and minutes
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if (days === 0) {
        return hours + " hours " + minutes + " minutes ";
      } else {
        return days + " days " + hours + " hours " + minutes + " minutes ";
      }
    }
  } else {
    return null
  }
}
